import { render, staticRenderFns } from "./x3-contract-detail.vue?vue&type=template&id=4f4ffb7a&scoped=true&"
import script from "./x3-contract-detail.vue?vue&type=script&lang=js&"
export * from "./x3-contract-detail.vue?vue&type=script&lang=js&"
import style0 from "./x3-contract-detail.vue?vue&type=style&index=0&id=4f4ffb7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ffb7a",
  null
  
)

export default component.exports